// extracted by mini-css-extract-plugin
export default {"socialContainer":"Social_socialContainer__wbv7+","icon":"Social_icon__dUys3"};